import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../data/mock';
import { ArrowRight, Hammer, Leaf, Sparkles, PartyPopper } from 'lucide-react';

// Modification #5: Nouvel ordre - 1. Bricolage, 2. Jardinage, 3. Nettoyage, 4. Événementiel
const iconMap = {
  1: Hammer,      // Bricolage
  2: Leaf,        // Jardinage
  3: Sparkles,    // Nettoyage
  4: PartyPopper  // Événementiel
};

const slugMap = {
  1: 'bricolage-travaux',
  2: 'jardinage-motoculture',
  3: 'nettoyage-logement',
  4: 'evenementiel-barnum'
};

// Modification #4: Phrases d'accroche personnalisées CORRIGÉES
// BRICO->"Trouvez le bon outil", JARDIN->"Découvrir les produits", NETTOYAGE->"Trouvez votre bonheur", EVENEMENT->"Voir le catalogue"
const ctaTexts = {
  1: "Trouvez le bon outil",
  2: "Découvrir les produits",
  3: "Trouvez votre bonheur",
  4: "Voir le catalogue"
};

const UniversShowcase = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-green-100 text-green-600 font-semibold rounded-full text-sm mb-4">
            Nos 4 Univers
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-800 mb-4">
            Explorez nos <span className="text-green-500">univers</span>
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            Matériel de qualité professionnelle pour tous vos projets
          </p>
        </div>

        {/* Universe Cards Grid - Modification #8: Harmonisation des hauteurs */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {services.map((service) => {
            const IconComponent = iconMap[service.id];
            const slug = slugMap[service.id];
            const ctaText = service.ctaText || ctaTexts[service.id];
            
            return (
              <div
                key={service.id}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500"
                data-testid={`univers-card-${slug}`}
              >
                {/* Background Image */}
                <div className="relative h-80">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  {/* Gradient Overlay */}
                  <div 
                    className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"
                  />
                  
                  {/* Color accent overlay on hover */}
                  <div 
                    className="absolute inset-0 opacity-0 group-hover:opacity-20 transition-opacity duration-500"
                    style={{ backgroundColor: service.color }}
                  />
                </div>

                {/* Content - Modification #8 & #12: Alignement avec min-height + flex pour boutons */}
                <div className="absolute bottom-0 left-0 right-0 p-6 flex flex-col">
                  {/* Modification #2: Icon Badge devant chaque univers */}
                  <div 
                    className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110"
                    style={{ backgroundColor: service.color }}
                  >
                    <IconComponent size={24} className="text-white" />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-white mb-2">
                    {service.title}
                  </h3>

                  {/* Features preview - Modification #2: Liste complète des sous-catégories */}
                  <p className="text-white/70 text-sm mb-4 min-h-[2.5rem] line-clamp-2">
                    {service.id === 1 && "Minipelle - Bétonnière - Compacteuse - Échaf"}
                    {service.id === 2 && "Motoculteur - Broyeur - Tarière - Fendeuse"}
                    {service.id === 3 && "Shampouineuse - Nettoyeur HP - Aspirateur"}
                    {service.id === 4 && "Barnums & Tentes - Mobilier & Vaisselle - Gonflables"}
                  </p>

                  {/* Modification #4: Link with custom CTA text + #14: Bouton "Voir le matériel" */}
                  <div className="flex flex-col gap-2 mt-auto">
                    <Link
                      to={`/univers/${slug}`}
                      className="inline-flex items-center gap-2 text-white font-semibold text-sm group/link"
                      data-testid={`univers-link-${slug}`}
                    >
                      <span 
                        className="px-4 py-2 rounded-full transition-all duration-300"
                        style={{ backgroundColor: service.color }}
                      >
                        Voir le matériel
                      </span>
                      <ArrowRight 
                        size={16} 
                        className="opacity-0 -translate-x-2 group-hover/link:opacity-100 group-hover/link:translate-x-0 transition-all duration-300"
                        style={{ color: service.color }}
                      />
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Modification #9: Main CTA Button - "Contactez-nous pour en savoir +" */}
        <div className="text-center">
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            data-testid="discover-catalog-btn"
          >
            <span>Contactez-nous pour en savoir +</span>
            <ArrowRight size={20} className="animate-pulse" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default UniversShowcase;
